import React, { useEffect, useState, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { Headphones, ExternalLink } from "lucide-react";
import { apiClient } from "../../../config/api";
import API_CONFIG from "../../../config/api";
import { Link } from "react-router-dom";
import customerServiceImage from "../../../Images/customer-support.svg";

export default function CustomerRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        setLoading(true);
        setError(null);
        const { data } = await apiClient.get(API_CONFIG.ENDPOINTS.CUSTOMER_REQUESTS, {
          headers: { Accept: "application/json" },
        });
        const list = Array.isArray(data) ? data : [];
        const sorted = [...list].sort((a, b) =>
          new Date(b.createdAt || b.CreatedAt || 0) - new Date(a.createdAt || a.CreatedAt || 0)
        );
        setRequests(sorted.slice(0, 3));
      } catch (err) {
        console.error("Failed to load customer requests", err);
        setError(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, []);

  const renderTitle = (req) =>
    req.title || req.Title || req.subject || req.Subject || "Customer Request";
  const renderDesc = (req) =>
    req.description ||
    req.Description ||
    req.summary ||
    req.Summary ||
    "No description provided.";
  const renderId = (req) => req.id || req.requestId || req.RequestId || req.customerRequestId || "-";

  return (
    <Box className="dashboard__customer-requests">
      <Box className="dashboard__customer-requests__header">
        <Box className="dashboard__customer-requests__header-icon">
          <img src={customerServiceImage} alt="Customer Service" />
        </Box>
        <Box className="dashboard__customer-requests__header-text">
          <Typography variant="h5" className="dashboard__widget-title">
            Customer Request
          </Typography>
          <Typography variant="body2" className="dashboard__widget-subtitle">
            We're reviewing your request and will keep you informed
          </Typography>
        </Box>
      </Box>

      <Box className="dashboard__customer-requests__list">
        {loading && <div className="text-muted">Loading customer requests…</div>}
        {error && <div className="text-muted">Failed to load: {error}</div>}
        {!loading && !error && !requests.length && (
          <div className="text-muted">No customer requests available.</div>
        )}
        {!loading &&
          !error &&
          requests.map((request, index) => (
            <Box key={index} className="dashboard__customer-requests__item">
              <Box className="dashboard__customer-requests__item-left">
                <Box className="dashboard__customer-requests__id-section">
                  <span className="dashboard__customer-requests__id-label">ID</span>
                  <span className="dashboard__customer-requests__id-value">
                    {renderId(request)}
                  </span>
                </Box>
                <Box className="dashboard__customer-requests__content">
                  <Typography className="dashboard__customer-requests__title">
                    {renderTitle(request)}
                  </Typography>
                  <Typography className="dashboard__customer-requests__description">
                    {renderDesc(request)}
                  </Typography>
                </Box>
              </Box>
              <Box className="dashboard__customer-requests__action">
                {renderId(request) ? (
                  <Link to={`/customer-requests/${renderId(request)}`} title="Open request">
                    <ExternalLink size={18} />
                  </Link>
                ) : (
                  <ExternalLink size={18} />
                )}
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  );
}
